import { graphql } from '@/gql';
import type { DeletePlanMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deletePlan = async (variables: DeletePlanMutationVariables) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeletePlan($id: String!) {
        deletePlan(id: $id) {
          id
          name
          kind
          amount
          isActive
          hasTrial
          trialPrice
          tier
          isDefault
          fragmentInto
          defragmentInto
          upgradeInto
          data
        }
      }
    `),
    variables,
  });

  if (!response.data?.deletePlan) {
    throw new Error('Failed to delete plan');
  }

  return response.data.deletePlan;
};
